
import state from './moduleVideoLibraryState'
import mutations from './moduleVideoLibraryMutations'
import actions from './moduleVideoLibraryActions'
import getters from './moduleVideoLibraryGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
